import React from 'react';
import logo from './img/caete-florestal-logo.png';

class Login extends React.Component {

    constructor() {

        super();

        this.state = {
            email: "",
            senha: "",
            errMsg: ""
        };

        this.updateEmail = this.updateEmail.bind(this);
        this.updateSenha = this.updateSenha.bind(this);
        this.entrar = this.entrar.bind(this);

    }

    updateEmail(e) {
        this.setState({email: e.target.value});
    }

    updateSenha(e) {
        this.setState({senha: e.target.value});
    }

    entrar() {

        let filter = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

        if (this.state.email === "") {

            this.setState({ errMsg: "Por favor, digite o seu E-mail." });

        } else if (!filter.test(this.state.email)) {

            this.setState({ errMsg: "Por favor, digite um E-mail válido." });

        } else if (this.state.senha === "") {

            this.setState({ errMsg: "Por favor, digite a sua senha." });

        } else {

            let obj = {
                "email": this.state.email,
                "senha": this.state.senha
            };

            fetch("/api/usuario/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg !== "success") {

                    this.setState({ errMsg: responseJson.msg });

                } else {

                    this.setState({ errMsg: "" });

                    localStorage.usuarioInfo = JSON.stringify(responseJson.usuarioInfo);
                    localStorage.auth = responseJson.usuarioInfo.email
                        + ":" + responseJson.usuarioInfo.token;

                    localStorage.successMsg = "";

                    let role = responseJson.usuarioInfo.role.split(";");
                    localStorage.roleUsuarios = role[0].split("=")[1];
                    localStorage.roleCentros = role[1].split("=")[1];
                    localStorage.roleEstoque = role[2].split("=")[1];
                    localStorage.roleContas = role[3].split("=")[1];
                    localStorage.roleMovimentacoes = role[4].split("=")[1];
                    localStorage.roleRelatorios = role[5].split("=")[1];

                    window.location.href = "/home";

                }

            });

        }

    }

    componentDidMount() {

        if (localStorage.usuarioInfo !== null && localStorage.usuarioInfo !== undefined) {
            window.location.href = "/home";
        }

    }

    render() {
        return (
            <div id="login-div">
                <div id="login-header-div">
                    <img src={logo} id="login-logo" alt="logo" />
                </div>
                <div id="login-login">
                    <form>
                        <input type="text" placeholder="E-mail" value={this.state.email} onChange={this.updateEmail} /><br />
                        <input type="password" placeholder="Senha" value={this.state.senha} onChange={this.updateSenha} /><br />
                        <button type="button" onClick={this.entrar}>Entrar</button>
                        <a href="/esqueceusenha">Esqueceu a senha?</a>
                        <p id="login-err-msg">{ this.state.errMsg }</p>
                    </form>
                </div>
            </div>
        );
    }

}

export default Login;

